import { render, staticRenderFns } from "./MealAudit.vue?vue&type=template&id=516ce474&scoped=true&"
import script from "./MealAudit.vue?vue&type=script&lang=js&"
export * from "./MealAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516ce474",
  null
  
)

export default component.exports